var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-2"},[_c('canvas',{ref:"my-canvas",staticStyle:{"border":"2px solid black","width":"256px","height":"256px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }